import { uploadFileV2 } from '@dealstack/frontend/shared/dataExchange/services/mip.service';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { useWrappedRequest } from '@dealstack/frontend/shared/other/react/ApiWrapper';
import { Dispatch, SetStateAction } from 'react';
import { DataFileTct } from '@dealstack/shared/lib/generated';

export enum UPLOAD_BUTTON_VARIANT {
	UPLOAD = 'upload',
	UPLOADED = 'uploaded',
}

interface Props {
	setUploadedDocument: Dispatch<SetStateAction<DataFileTct | undefined>>;
	setUploadButtonVariant: Dispatch<SetStateAction<UPLOAD_BUTTON_VARIANT>>;
	toastFileUploadedText: string;
}

export const useWetInkModalFileHook = (props: Props) => {
	const { setUploadedDocument, setUploadButtonVariant, toastFileUploadedText } = props;

	const uploadFileRequest = useWrappedRequest(uploadFileV2);
	const onFileDrop = (file: File) => {
		uploadFileRequest.fetch(file).onSuccess((result) => {
			const file = result?.payload;
			if (file?.id) {
				setUploadedDocument(file);
			}
			setUploadButtonVariant(UPLOAD_BUTTON_VARIANT.UPLOADED);
			showToastV2({ title: toastFileUploadedText });
			setTimeout(() => {
				setUploadButtonVariant(UPLOAD_BUTTON_VARIANT.UPLOAD);
			}, 5000);
		});
	};

	const onDelete = () => {
		setUploadedDocument(undefined);
		setUploadButtonVariant(UPLOAD_BUTTON_VARIANT.UPLOAD);
	};

	return { onFileDrop, onDelete, uploadFileRequest };
};
